import { Card } from "../../models/card";
export class Wood extends Card {
}
Wood.displayName = "Wood";
Wood.artUrl = "./assets/cards/wood.jpg";
